import { render } from "./ChangeHostPassword.vue?vue&type=template&id=cd9fd1f2&scoped=true"
import script from "./ChangeHostPassword.vue?vue&type=script&lang=js"
export * from "./ChangeHostPassword.vue?vue&type=script&lang=js"

import "./ChangeHostPassword.vue?vue&type=style&index=0&id=cd9fd1f2&scoped=true&lang=less"

import exportComponent from "/mnt/build/cloudstack/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cd9fd1f2"]])

export default __exports__